module.exports = __webpack_public_path__ + "img/chevy02.9db743f0.png";